import { render, staticRenderFns } from "./loading-review-card.vue?vue&type=template&id=30f4bcf9&scoped=true&"
import script from "./loading-review-card.vue?vue&type=script&lang=js&"
export * from "./loading-review-card.vue?vue&type=script&lang=js&"
import style0 from "./loading-review-card.vue?vue&type=style&index=0&id=30f4bcf9&lang=scss&scoped=true&"
import style1 from "./loading-review-card.vue?vue&type=style&index=1&id=30f4bcf9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f4bcf9",
  null
  
)

export default component.exports
import {QCard,QCardSection,QAvatar,QSkeleton} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QCardSection,QAvatar,QSkeleton})
